/**
 * RCD — Retail CD Management routes.
 *
 * Surfaces per modules digest §RCD + procedures digest §2.5:
 *   /rcd                       → dashboard (maturing soon + recently matured + by-branch list)
 *   /rcd/cd/:acctId            → single-CD detail record (stage ribbon)
 *   /rcd/cd/:acctId/maturity   → maturity instruction editor
 *   /rcd/cd/:acctId/waive      → penalty waiver wizard (split authority)
 *   /rcd/cd/:acctId/lost       → Lost CD indemnity form (v25.0 digitization)
 */
import { Routes, Route } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import RcdDashboard from './index';
import { CdDetail } from './CdDetail';
import { MaturityViewer } from './MaturityViewer';
import { PenaltyWaiverWizard } from './PenaltyWaiverWizard';
import { LostCdForm } from './LostCdForm';

export function RcdRoutes(): JSX.Element {
  return (
    <Routes>
      <Route index element={<RcdDashboard />} />
      <Route path="cd/:acctId" element={<CdDetail />} />
      <Route path="cd/:acctId/maturity" element={<MaturityViewer />} />
      <Route path="cd/:acctId/waive" element={<PenaltyWaiverWizard />} />
      <Route path="cd/:acctId/lost" element={<LostCdForm />} />
      <Route path="*" element={<SplatRedirect />} />
    </Routes>
  );
}
